import React from 'react';
//import logo from './assets/visioN.svg';
import '../App.less';
import { 
    Button,
    Typography, 
    Divider,
    Row, 
    Col,
    Card,
    Image,
    Space,
    Avatar,
    Tabs
  } from 'antd';

  import Sticky from 'react-sticky-el';

const { 
  Text, 
  Title
} = Typography;

const gridStyle = {
  width: '50%',
  textAlign: 'center',
};

function SideBar() {
    if (typeof window.matchMedia === "function" && window.matchMedia("(min-width: 796px)").matches) 
    return (
        <div>
            <Sticky>
            <Row> 
                  <Image className="divImage" src={require("../assets/neel-main.png")}/>
                </Row>
                <Row className="m24-t">
                      <Title level={2}>I design<br></br>meaningful interventions</Title>
                      <Text className="m16-t sideDesc">
                        This body is identified as <strong>Neelank Sachan</strong>, the mind is ignited with curiosity to always learn and the soul is searching for meaning through the growth of ecosystem it exists in.
                        <br/><br/>
                        Interested in building preferable sustainable futures using connected environments
                      </Text>
                </Row>
                <Row className="p24-t">
                  <Space size={16}>
                    <a href="mailto:saineelank@gmail.com" target="_blank" rel="noopener noreferrer">
                      
                      <Button type="primary" className="divImage">
                        <Space align="center">
                        <span class="material-icons md-light m4-t">email</span>
                          Get in Touch
                        </Space> 
                      </Button>  
                    </a>

                    <a href="https://drive.google.com/file/d/1PBchC70-UvLPlpzTM3eR91wEP-16AHE0/view?usp=sharing" target="_blank" rel="noopener noreferrer">
                      <Space align="center" className="divImage">
                        <span class="material-icons md-light m4-t">file_download</span>
                        Resume
                      </Space> 
                    </a>
                  </Space>
                  
                </Row>
                
                
                <Row className="m48-t">
                  <Space size={16}>                    
                    <a href="https://www.linkedin.com/in/neelanksachan/" target="_blank" rel="noopener noreferrer"><Avatar className="divImage" src={require("../assets/home/16_li.png")}/></a>
                    <a href="https://dribbble.com/visualfart" target="_blank" rel="noopener noreferrer"><Avatar className="divImage" src={require("../assets/home/17_dr.png")}/></a>
                    <a href="https://github.com/visualfart" target="_blank" rel="noopener noreferrer"><Avatar className="divImage" src={require("../assets/home/18_gh.png")}/></a>
                    <a href="https://www.instagram.com/visualfart/" target="_blank" rel="noopener noreferrer"><Avatar className="divImage" src={require("../assets/home/19_in.png")}/></a>
                  </Space>
                </Row>
            </Sticky>
        </div>
    );
    
    else return (
      <div>
          
            <Row>
                  <Image className="divImage" src={require("../assets/neel-main.png")}/>
                </Row>
                <Row className="m24-t">
                      <Title level={2}>I design<br></br>meaningful interventions</Title>
                      <Text className="m16-t sideDesc">
                        This body is identified as <strong>Neelank Sachan</strong>, the mind is ignited with curiosity to always learn and the soul is searching for meaning through the growth of ecosystem it exists in.
                        <br/><br/>
                        Interested in building preferable sustainable futures using connected environments
                      </Text>
                </Row>
                <Row className="p24-t">
                  <Space size={16}>
                    <a href="mailto:saineelank@gmail.com" target="_blank" rel="noopener noreferrer">
                      
                      <Button type="primary" className="divImage">
                        <Space align="center">
                        <span class="material-icons md-light m4-t">email</span>
                          Get in Touch
                        </Space> 
                      </Button>  
                    </a>

                    <a href="https://drive.google.com/file/d/1PBchC70-UvLPlpzTM3eR91wEP-16AHE0/view?usp=sharing" target="_blank" rel="noopener noreferrer">
                      <Space align="center" className="divImage">
                        <span class="material-icons md-light m4-t">file_download</span>
                        Resume
                      </Space> 
                    </a>
                  </Space>
                  
                </Row>
                
                
                <Row className="m48-t">
                  <Space size={16}>                    
                    <a href="https://www.linkedin.com/in/neelanksachan/" target="_blank" rel="noopener noreferrer"><Avatar className="divImage" src={require("../assets/home/16_li.png")}/></a>
                    <a href="https://dribbble.com/visualfart" target="_blank" rel="noopener noreferrer"><Avatar className="divImage" src={require("../assets/home/17_dr.png")}/></a>
                    <a href="https://github.com/visualfart" target="_blank" rel="noopener noreferrer"><Avatar className="divImage" src={require("../assets/home/18_gh.png")}/></a>
                    <a href="https://www.instagram.com/visualfart/" target="_blank" rel="noopener noreferrer"><Avatar className="divImage" src={require("../assets/home/19_in.png")}/></a>
                  </Space>
                </Row>
      </div>
      );
  }
  
export default SideBar;